import { cn } from "@/lib/utils";

/**
 * Overlay a sweeping light reflection on any `relative overflow-hidden` parent.
 * Accepts an optional `delay` (CSS value) to stagger multiple shines.
 */
export function Shine({
  className,
  delay,
  duration = "2.5s",
}: {
  className?: string;
  delay?: string;
  duration?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        // motion-reduce:hidden: a sweep of white light is pure decoration, it lowers the contrast of
        // white text it passes under, and people who asked for less motion should not get it.
        "gs-shine pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent motion-reduce:hidden",
        className,
      )}
      style={{
        animation: `shine ${duration} ease-in-out infinite`,
        animationDelay: delay,
      }}
    />
  );
}
